import script from "./transfer-report.vue?vue&type=script&lang=js&setup=true"
export * from "./transfer-report.vue?vue&type=script&lang=js&setup=true"

const __exports__ = script;

export default __exports__